import type { AddModelRequest, AddModelResponse } from '@rock/types';
import { AddModelResponseSchema } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Add a catalog model by hand, server-side (`addModel`): the model and its `model-spellings` entry land
 * together. A number the catalog already holds for the type and brand comes back `exists`, not an error.
 */
export async function addModel(request: AddModelRequest): Promise<AddModelResponse> {
    const fn = httpsCallable<AddModelRequest, AddModelResponse>(getFunctions(), 'addModel');
    const result = await fn(request);
    return AddModelResponseSchema.parse(result.data);
}
